module.exports = __webpack_public_path__ + "e2790ea16eeea684c81d71ef1cafb223.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-zh.html
// module id = 1031
// module chunks = 0